var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoFloorPlan = function SvgNoFloorPlan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M10.572 57.824s-24.336 54.966 39.738 55.737 93.36-7.671 93.651-35.637-22.785-54.066-63.009-54.354c-40.224-.29-61.97 10.227-70.38 34.257z",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M119.482 33.606H72.487l.645 46.077h64.509V51.764c0-10.029-8.13-18.159-18.159-18.159"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F8F8F",
    d: "M67.602 33.606h9.762c7.33 0 13.278 5.948 13.278 13.277v32.8H54.324v-32.8c0-7.329 5.95-13.278 13.278-13.278"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M54.324 79.683h36.318v32.799c0 7.332-5.946 13.278-13.278 13.278h-9.762c-7.332 0-13.278-5.946-13.278-13.278z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M77.365 125.762h-9.762c-7.33 0-13.278-5.949-13.278-13.278v-32.8h36.318v32.8c0 7.329-5.95 13.278-13.278 13.278",
    opacity: 0.09
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M107.439 52.596h-2.127V13.965c0-.43.348-.777.777-.777h.574c.429 0 .776.348.776.776z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M106.089 13.188h.574c.429 0 .776.348.776.776v38.632h-2.127V13.965c0-.43.348-.777.777-.777",
    opacity: 0.44
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A4751",
    d: "M106.438 56.645a4.05 4.05 0 1 0 0-8.101 4.05 4.05 0 0 0 0 8.1M107.439 14.252h9.969v3.921l-9.969 2.526z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F8F8F",
    d: "M115.063 79.683H97.516v6.378h17.547z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M110.487 86.06h-8.541v50.752h8.541z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.487 86.06h-8.541v50.752h8.541z",
    opacity: 0.44
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M101.946 86.06v17.011l8.541-5.442V86.06z",
    opacity: 0.09
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A4751",
    d: "m34.034 28.764 2.394-10.899 2.114 8.262a4.54 4.54 0 0 0 3.325 3.282l6.126 1.485-5.68 1.66a5.6 5.6 0 0 0-3.81 3.83l-2.142 7.47-1.892-7.977a3.9 3.9 0 0 0-2.899-2.892l-5.507-1.293 7.976-2.925zM88.901 44.25l1.86-8.469 1.644 6.417a3.52 3.52 0 0 0 2.583 2.55l4.758 1.155-4.413 1.29a4.35 4.35 0 0 0-2.96 2.976l-1.663 5.802-1.47-6.198a3.02 3.02 0 0 0-2.253-2.247l-4.28-1.005 6.197-2.27zM31.148 84.598l1.28-5.832 1.132 4.419a2.42 2.42 0 0 0 1.779 1.755l3.276.795-3.04.888a3 3 0 0 0-2.04 2.049l-1.145 3.996-1.014-4.27a2.09 2.09 0 0 0-1.551-1.547l-2.946-.693 4.266-1.566zM62.288 65.076l.96-4.37.849 3.311a1.83 1.83 0 0 0 1.332 1.317l2.457.597-2.277.666a2.24 2.24 0 0 0-1.527 1.536l-.858 2.997-.76-3.198a1.57 1.57 0 0 0-1.163-1.16l-2.208-.52 3.198-1.173z"
  })));
};
export default SvgNoFloorPlan;